import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

class PI1FormSecActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValid: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  // TODO review ./services/pi1-form-content button submit content
  static defaultProps = {
    submitBtnText: "See available rates",
    submitBtnId: "pf-register-submit",
    submitBtnClass: "btn primary",
    wontImpactClass: "wont-impact-cs",
    formState: {
      hasErrored: false,
      hasErroredUnrecoverable: false,
      hasReqTimeout: false,
      hasCompletedBE: false,
      hasSubmittedBE: false,
    },
    lockApplicationFeatures: false,
  };

  handleClick(ev) {
    const { handleSubmit } = this.props;
    ev.preventDefault();
    handleSubmit();
  }

  render() {
    const {
        submitBtnText,
        submitBtnId,
        submitBtnClass,
        wontImpactClass,
        formState,
        lockApplicationFeatures,
      } = this.props,
      { hasSubmittedBE, hasCompletedBE, hasErroredUnrecoverable } = formState,
      btnDisabled = hasCompletedBE || hasSubmittedBE || hasErroredUnrecoverable || lockApplicationFeatures,
      btnGroupClasses = classnames({
        "button-group": true,
        disabled: btnDisabled,
        [wontImpactClass]: true,
      });

    return (
      <fieldset className="pf-registration section-5 application-actions">
        <legend className="show-for-sr">Call To Action</legend>
        <div className={btnGroupClasses}>
          <button
            id={submitBtnId}
            className={submitBtnClass}
            disabled={btnDisabled}
            onClick={this.handleClick}
          >
            {submitBtnText}
          </button>
        </div>
      </fieldset>
    );
  }
}

PI1FormSecActions.propTypes = {
  userType: PropTypes.string,
  submitBtnText: PropTypes.string.isRequired,
  submitBtnId: PropTypes.string.isRequired,
  submitBtnClass: PropTypes.string.isRequired,
  wontImpactClass: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  formState: PropTypes.object.isRequired,
  lockApplicationFeatures: PropTypes.bool,
};

export default PI1FormSecActions;

require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/src/pages/borrower-registration/styles/borrower-registration.scss');